import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, map, Observable, switchMap } from 'rxjs';
import { HttpHandler } from '../http/http-handler';
import { AppConfiguration } from '../settings/app-config';
import { AppConfigService } from '../settings/app-config.service';
import { RouteInfo } from '../vertical-menu/vertical-menu.metadata';
import { RFWebPermissaoEnum } from './permissao/cadastro-menu-routes-permission.config';

@Injectable()
export class AuthDataService {

  private authentication = new UserAuthenticationModel();
  private routingAuthentication = Array<number>();

  constructor(public router: Router
  ) {
    if (!this.isAuthenticated) {
      this.router.navigate(['/pages/login']);
    }
  }

  adicionarDadosUsuario(dados :UserAuthenticationModel) {
    localStorage.setItem('authorizationData', JSON.stringify({
      token: dados.token,
      userName: dados.userName,
      refreshToken: dados.refreshToken,
      cdRole: dados.cdRole,
      email: dados.email
    }));

    this.authentication.isAuth = true;
    this.authentication.userName = dados.userName;
    this.authentication.cdRole = dados.cdRole;
    this.authentication.token = dados.token;
    this.authentication.refreshToken = dados.refreshToken;
    this.authentication.email = dados.email;
  }

  adicionarDadosRota(dados : Array<number>) {
    localStorage.setItem('routingData', JSON.stringify({
      rotasAutenticadas: dados
    }));

    this.routingAuthentication = dados;
  }

  removerDadosUsuario() {
    localStorage.removeItem('authorizationData');
    this.authentication = new UserAuthenticationModel();
  }

  removerDadosRota() {
    localStorage.removeItem('routingData');
    this.routingAuthentication = Array<number>();
  }

  isRoutingAuthenticated() {
    if (!this.routingAuthentication || this.routingAuthentication.length == 0) {
      let data = localStorage.getItem('routingData');
      const routingData = JSON.parse(data);
      if (routingData) {
        this.routingAuthentication = routingData.rotasAutenticadas;
      }
    }
    return this.routingAuthentication && this.routingAuthentication.length > 0;
  }

  isAuthenticated() {
    if (!this.authentication.userName) {
      const authorizationDataStr = localStorage.getItem('authorizationData');
      if (authorizationDataStr) {
        const authorizationData = JSON.parse(authorizationDataStr);
        this.authentication.isAuth = true;
        this.authentication.userName = authorizationData.userName;
        this.authentication.cdRole = authorizationData.cdRole;
        this.authentication.token = authorizationData.token;
        this.authentication.refreshToken = authorizationData.refreshToken;
        this.authentication.email = authorizationData.email;
      }
    }

    return this.authentication.isAuth;
  }

  public getUserToken() {
    return this.authentication.token;
  }
  // TODO: Rever
  public get usuario(): UserAuthenticationModel {
    return this.authentication;
  }
  public get rotasAutenticadas(): Array<number> {
    return this.routingAuthentication;
  }

}

export class UserAuthenticationModel {
  isAuth: boolean = false;
  userName: string = '';
  cdRole: number = 0;
  token: string;
  refreshToken: string;
  email: string;
}
